<div class="flex flex-col gap-4">
  <div class="flex items-start justify-between gap-4">
    <h2 class="m-0 text-lg font-bold text-midnight">
      {{ isEditMode ? 'Edit ' + sourceLabel : 'Add Seal' }}
    </h2>
    <button type="button" mat-dialog-close aria-label="Close dialog">
      <img src="assets/icons/close.svg" alt="Close" class="w-4 h-4" />
    </button>
  </div>

  <form [formGroup]="form" (ngSubmit)="onSubmit()" class="grid gap-4">
    <div class="grid grid-cols-2 gap-4">
      <et-atoms-select-field class="w-full">
        <label>Notarial act</label>
        <et-atoms-select-input formControlName="notorialAct" required>
          @for (option of notorialActOptions; track option) {
          <et-atoms-select-option [value]="option">
            {{ option }}
          </et-atoms-select-option>
          }
        </et-atoms-select-input>
        @if (form.controls.notorialAct.touched &&
        form.controls.notorialAct.invalid) {
        <span etAtomsSelectError>Notarial act is required</span>
        }
      </et-atoms-select-field>

      <et-atoms-input class="w-full">
        <label>Document name</label>
        <input
          etAtomsInput
          formControlName="documentDescription"
          type="text"
          required
        />
        @if (form.controls.documentDescription.touched &&
        form.controls.documentDescription.invalid) {
        <span etAtomsInputError>Document description is required</span>
        }
      </et-atoms-input>

      <et-atoms-input class="w-full">
        <label>Fee charged</label>
        <input
          etAtomsInput
          interfaceCurrencyFormatter
          [maximumFractionDigits]="2"
          formControlName="feeCharged"
          required
        />
        @if (form.controls.feeCharged.touched &&
        form.controls.feeCharged.invalid) {
        <span etAtomsInputError>Fee charged is required</span>
        }
      </et-atoms-input>

      @if (!lockAuditFields) {
      <et-atoms-input class="w-full">
        <label>Page number</label>
        <input
          etAtomsInput
          formControlName="pageNumber"
          type="number"
          min="1"
          step="1"
        />
      </et-atoms-input>

      <div class="relative w-full">
        <input
          interfacePreventTyping
          formControlName="notarizationDate"
          [dpDayPicker]="datePickerConfig"
          placeholder="Notarization date*"
          class="w-full text-base font-medium bg-transparent text-midnight input input-bordered placeholder-secondary-focus focus:outline-midnight focus:border-transparent focus:outline-offset-0"
        />
        @if (form.controls.notarizationDate.touched &&
        form.controls.notarizationDate.invalid) {
        <span class="text-sm text-error font-medium ml-6"
          >Notarization date is required</span
        >
        }
      </div>

      <et-atoms-time-field class="w-full">
        <label>Notarization time</label>
        <et-atoms-time-input
          formControlName="notarizationTime"
          required
        ></et-atoms-time-input>
        @if (form.controls.notarizationTime.touched &&
        form.controls.notarizationTime.invalid) {
        <span etAtomsTimeError>Notarization time is required</span>
        }
      </et-atoms-time-field>
      }

      <div class="w-full col-span-2 px-[2px]">
        <label class="block mb-1 text-sm font-medium text-secondary"
          >Notes</label
        >
        <textarea
          formControlName="notes"
          rows="3"
          class="w-full px-6 py-3 font-medium border rounded-lg focus:outline-midnight text-midnight"
          placeholder="Enter notes for this seal entry..."
        ></textarea>
      </div>
    </div>

    @if (error(); as err) {
    <p class="text-error m-0">{{ err }}</p>
    }

    <div class="flex justify-end gap-3">
      <button
        type="button"
        mat-dialog-close
        class="btn btn-outline normal-case rounded-full min-w-[120px]"
      >
        Cancel
      </button>
      <button
        type="submit"
        class="btn btn-primary normal-case rounded-full min-w-[120px]"
        [disabled]="isLoading()"
      >
        @if (isLoading()) {
        <et-atoms-spinner size="small"></et-atoms-spinner>
        } @else {
        {{ isEditMode ? 'Save' : 'Add Seal' }}
        }
      </button>
    </div>
  </form>
</div>
